export const organizationFeatureKey = 'organization';

export interface OrganizationState {
    activeIntegrations: Record<string, { data: string }>;
}

export function createInitialOrganizationState(): OrganizationState {
    return {
        activeIntegrations: {},
    };
}
